import React from "react";

class Validator {
  static validPostCode(value) {
    const pattern = new RegExp(/[\s\S][\s\S] \d\w\w$/);
    return pattern.test(value);
  }

  static validLatitude(value) {
    const pattern = new RegExp(/^(\d\d).\d\d\d\d\d\d$/);
    return pattern.test(value);
  }

  static validLongitude(value) {
    const pattern = new RegExp(/^(\d\d\d).\d\d\d\d\d\d$/);
    return pattern.test(value);
  }

  static validEcdsFormLenght = (min, max, data) => {
    if (!data || typeof data === "undefined") {
      return false;
    }
    if (data.__code) {
      const value = data.__code.toString().length;
      return value >= min && value <= max;
    } else {
      const value = data.toString().length;
      return value >= min && value <= max;
    }
  };
}

export default Validator;
